import {Chicken, Fish, Icecream, Strawberry} from "../components/Assets";
import greenchicken from "../img/greenchicken.png";
import miniidli from "../img/miniidli.png";
import bananacurry from "../img/bananacurry.png";
import lycheecurry from "../img/lycheecurry.png";

export const data = [
    {
        id: 1,
        title: 'MINI IDLI',
        desc: "Steamed rice cakes",
        price: '8.99',
        imgSrc: miniidli
    },
    {   
        id: 2,
        title: 'SPECIAL GOAT CURRY',
        desc: "Signature goat curry",
        price: '15.99',
        imgSrc: greenchicken
    },
    {
        id: 3,
        title: 'BUTTER CHICKEN MASALA',
        desc: "Chicken in butter sauce",
        price: '14.99',
        imgSrc: lycheecurry
    },
    {
        id: 4,
        title: 'HYDERABADI CHICKEN DUM BIRYANI',
        desc: "Slow-cooked chicken biryani",
        price: '14.99',
        imgSrc: bananacurry
    },
]